module.exports = __webpack_public_path__ + "img/konvert.f506e45a.svg";